module.exports = __webpack_public_path__ + "img/icon_map_38_off_001.3fb34df7.png";